import xyncely from "../assets/svg/Xyncely.svg";
import hypex from "../assets/svg/Hypex.svg";
import xyncelywhite from "../assets/svg/XyncelyWhite.svg";

import TwitterIcon from "../assets/svg/Twitter.svg";
import LinkedInIcon from "../assets/svg/LinkedIn.svg";
import InstagramIcon from "../assets/svg/Instagram.svg";
import YoutubeIcon from "../assets/svg/Youtube.svg";
import WhatsappIcon from "../assets/svg/Whatsapp.svg"
import FacebookIcon from "../assets/svg/Facebook.svg"

import PeopleImage from "../assets/svg/People.svg"

export const XyncelyLogo = xyncely;
export const HypexLogo = hypex;
export const XyncelyWhite = xyncelywhite;

export const Twitter = TwitterIcon;
export const LinkedIn = LinkedInIcon;
export const Instagram = InstagramIcon;
export const Whatsapp = WhatsappIcon;
export const Facebook = FacebookIcon;

export const People = PeopleImage;